import { DollarOutlined, FileSearchOutlined, IdcardOutlined, LockOutlined, SettingOutlined, TeamOutlined, ToolOutlined, UserOutlined } from '@ant-design/icons';
import { Navigate, useResolvedPath } from 'react-router-dom';
import { StaffLandingPageStaffRoleFieldsFragment, StaffRole } from '../../generated';

interface LandingPageProps {
  roleData: StaffLandingPageStaffRoleFieldsFragment
}

export interface PageLayoutProps {
  path: string;
  title: string;
  icon: React.JSX.Element;
  id: string | number;
  parent?: string;
  hasPermissions?: (role: StaffRole) => boolean;
}


export const LandingPage: React.FC<LandingPageProps> = (props) => {

const casesRoutePath = useResolvedPath('cases');
const applicantRoutePath = useResolvedPath('applicants');
const entitiesRoutePath = useResolvedPath('entities');
const rolesRoutePath = useResolvedPath('roles');
const isConfigRoutePath = useResolvedPath('is-config');
const financeConfigRoutePath = useResolvedPath('finance-config');
const staffRoutePath = useResolvedPath('staff');
const toolsRoutePath = useResolvedPath('tools');

const pageLayouts: PageLayoutProps[] = [
    {
      path: `${casesRoutePath.pathname}`,
      title: 'Cases',
      icon: <FileSearchOutlined />,
      id: '1',
      hasPermissions: (role) => {
        return (
          role?.permissions?.idCasePermissions?.canSearchCases ||
          role?.permissions?.credCasePermissions?.canSearchCases ||
          role?.permissions?.sendCasePermissions?.canSearchCases
        );
      }
    },
    {
      path: `${applicantRoutePath.pathname}`,
      title: 'Applicants',
      icon: <UserOutlined />,
      id: '2',
      parent: 'ROOT',
      hasPermissions: (role) => {
        return role?.permissions?.applicantUserPermissions?.canSearchApplicants;
      }
    },
    {
      path: `${entitiesRoutePath.pathname}`,
      title: 'Entities',
      icon: <TeamOutlined />,
      id: '3',
      parent: 'ROOT',
      hasPermissions: (role) => {
        return role?.permissions?.entityPermissions?.canSearchEntities;
      }
    },
    {
      path: `${rolesRoutePath.pathname}`,
      title: 'Roles',
      icon: <LockOutlined />,
      id: '4',
      parent: 'ROOT',
      hasPermissions: (role) => {
        return role?.permissions?.rolePermissions?.canSearchRoles;
      }
    },
    {
      path: `${isConfigRoutePath.pathname}`,
      title: 'IS Config',
      icon: <SettingOutlined />,
      id: '5',
      parent: 'ROOT',
      hasPermissions: (role) => {
        return role?.roleSubtype === 'Staff.IS';
      }
    },
    {
      path: `${financeConfigRoutePath.pathname}`,
      title: 'Finance',
      icon: <DollarOutlined />,
      id: '6',
      parent: 'ROOT',
      hasPermissions: (role) => {
        return role?.roleSubtype === 'Staff.Finance' || role?.roleSubtype === 'Staff.IS';
      }
    },
    {
      path: `${staffRoutePath.pathname}`,
      title: 'Staff',
      icon: <IdcardOutlined />,
      id: '7',
      parent: 'ROOT',
      hasPermissions: (role) => {
        return role?.permissions?.staffUserPermissions?.canSearchStaff;
      }
    },
    {
      path: `${toolsRoutePath.pathname}`,
      title: 'Tools',
      icon: <ToolOutlined />,
      id: '8',
      parent: 'ROOT'
    }
  ];

  
  const hasPermission = (layout: PageLayoutProps, roleData: StaffLandingPageStaffRoleFieldsFragment) =>
    !layout.hasPermissions || (roleData && layout.hasPermissions(roleData as StaffRole));

  const layoutTitle = pageLayouts.find((layout) => hasPermission(layout, props.roleData))?.title || "tools";

  
  return (
    <Navigate to={`/staff/${layoutTitle?.toString().toLowerCase()}`} />
  )
};